import moment from 'moment'

export const MINIMUM_EFFECTIVE_AT = new Date(1970, 0, 1)
export const MINIMUM_EFFECTIVE_AT_MOMENT = moment(MINIMUM_EFFECTIVE_AT)
